export enum QrGeneratorNavigatorSteps {
  FINAL = "final",
  START = "start",
  CUSTOMIZE = "customize",
}
